// import { Helmet } from 'react-helmet'
import { Helmet } from 'react-helmet-async'
import i18next from 'i18next'

const Header = (): JSX.Element => {
  const title = process.env.REACT_APP_BRAND ?? 'SET APP BRAND NAME IN .env FILE'

  const cspUrls = process.env.REACT_APP_CSP_URLS_WHITELIST ?? ''

  const cspValue = `
    default-src 'self';
    script-src 'self';
    style-src 'self';
    object-src 'none';
    form-action 'self';
    base-uri 'self';
    connect-src 'self' ${cspUrls} fonts.gstatic.com;
    font-src 'self' fonts.gstatic.com;
    frame-src 'self';
    img-src 'self' data: blob: ${cspUrls};
    manifest-src 'self';
    media-src 'self';
    worker-src 'none';
    style-src-elem 'self' 'unsafe-inline';
    style-src-attr 'self' 'unsafe-inline';
  `

  return (
    <Helmet defaultTitle={title}>
      <html lang={i18next.language} />
      <meta charSet="utf-8" />
      <title>{title}</title>
      <link rel="icon" href="favicon.ico" />
      <meta name="viewport" content="width=device-width initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      <meta name="description" content={`Welcome to ${title} management system`} />
      <meta httpEquiv="Content-Security-Policy" content={cspValue} />
    </Helmet>
  )
}

export default Header
